module.exports = __webpack_public_path__ + "static/media/02.280aaba0.jpg";